const COUCH_MARK_KEY = 'WOODS_COUCH_MARK_COUNT';
const MAX_VISIBILITY_COUNT = 3;

export const getCouchMarkCount = () => {
  return parseInt(localStorage.getItem(COUCH_MARK_KEY) || '0', 10);
};

export const incrementCouchMarkCount = () => {
  const currentCount = getCouchMarkCount();
  const newCount = currentCount + 1;
  localStorage.setItem(COUCH_MARK_KEY, newCount.toString());
  return newCount;
};

export const disableCouchMark = () => {
  localStorage.setItem(COUCH_MARK_KEY, MAX_VISIBILITY_COUNT.toString());
};

export const shouldShowCouchMark = () => {
  return getCouchMarkCount() < MAX_VISIBILITY_COUNT;
};
